export const getCategoryName = category => {
  switch (category) {
    case 'campaign':
      return 'Email 活動';
    case 'lists':
      return '名單管理';
    case 'payment':
      return '購買';
    case 'marketing':
      return '行銷建議';
    case 'automation':
      return '自動化腳本';
    case 'system':
      return '系統設定';
    case 'sms':
      return '簡訊活動';
    case 'page':
      return '行銷網頁';
    default:
      return '';
  }
};

export const getHelpTypeName = type =>
  type === 'nlHelpCenter' ? 'Newsleopard 常見問題' : 'Surenotify 常見問題';
